import type { Auth } from 'backend/src/lib/auth';
import { inferAdditionalFields } from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/react';

export const authClient = createAuthClient({
  plugins: [
    //
    inferAdditionalFields<Auth>(),
  ],
});
